import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import HomePage from './pages/HomePage';
import { Routes, Route } from 'react-router';
import Navbar from './components/Navbar/Navbar';
import ContactUsPage from './pages/ContactUsPage';
import AboutUsPage from './pages/AboutUsPage';
import VacationNoticePage from './pages/VacationNoticePage';

function App() {
  const links = [
    {
      name: 'Home',
      to: '/',
      active: true,
    },
    {
      name: 'About Us',
      to: '/about-us',
      active: false,
    },
    {
      name: 'Contact Us',
      to: '/contact-us',
      active: false,
    },
  ];

  return (
    <>
      <Navbar navLinks={links} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/vacation-notice" element={<VacationNoticePage />} />
      </Routes>
      <p style={{ textAlign: 'center' }}>&copy; All rights reserved</p>
    </>
  );
}

export default App;
